export default "__VITE_ASSET__RicAv$QJ__"